import { getSpotConfig } from '@host-panel/request/config';

export async function getIsEmbeddedAnalyticsEnabled(spotId: string) {
  const { tenant: configResult } = await getSpotConfig(spotId, [
    'tenant.host_panel.isEmbeddedAnalyticsEnabled'
  ]);
  return configResult?.['host_panel']?.isEmbeddedAnalyticsEnabled?.value;
}
